import angular from 'angular';

const rebusServices = angular.module('applicationModule.rebusesServices', []);

rebusServices.factory('Rebus', ['RebusAPI', function (RebusAPI) {
    'use strict';

    return {
        getList: function (appId, params) {
            return RebusAPI.getList(appId, params).then(function (response) {
                return response.data;
            });
        },
        get: function (rebusId) {
            return RebusAPI.getRebus(rebusId);
        },
        save: function (rebus, editMode) {
            if (editMode) {
                return RebusAPI.editRebus(rebus);
            } else {
                return RebusAPI.createRebus(rebus);
            }
        },
        remove: function (rebusId) {
            return RebusAPI.removeRebus(rebusId);
        },
        autocompleteLevels: function (text) {
            return RebusAPI.autocompleteLevels(text);
        }
    };
}]);

rebusServices.service('RebusAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/app/rebus/';

    this.getList = function (appId, params) {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {app_id: appId})});
    };

    this.createRebus = function (rebus) {
        return $http.post(API_URL, rebus);
    };
    this.getRebus = function (rebusId) {
        return $http.get(API_URL + rebusId);
    };

    this.editRebus = function (rebus) {
        return $http.put(API_URL + rebus.id, rebus);
    };

    this.removeRebus = function (rebusId) {
        return $http.delete(API_URL + rebusId);
    };

    this.autocompleteLevels = function (appId, text) {
        return $http.get(API_URL + 'autocomplete-levels/' + appId, {search: text});
    };

}]);

rebusServices.factory('PendingRebus', ['PendingRebusAPI', function (PendingRebusAPI) {
    'use strict';

    return {
        getList: function (appId) {
            return PendingRebusAPI.getList(appId);
        },
        remove: function (rebusId) {
            return PendingRebusAPI.removeRebus(rebusId);
        }
    };
}]);

rebusServices.service('PendingRebusAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/app/pending-rebus/';

    this.getList = function (appId) {
        return $http.get(API_URL, {params: {app_id: appId}});
    };

    this.removeRebus = function (rebusId) {
        return $http.delete(API_URL + rebusId);
    };

}]);

export default rebusServices;
